// tslint:disable
export var EmailErrorCode;
(function (EmailErrorCode) {
    // No Error
    EmailErrorCode[EmailErrorCode["NoError"] = 0] = "NoError";
    // User Id Not Found
    EmailErrorCode[EmailErrorCode["UserIdNotFound"] = 1] = "UserIdNotFound";
    // Bronto Error
    EmailErrorCode[EmailErrorCode["BrontoError"] = 2] = "BrontoError";
    // General Error
    EmailErrorCode[EmailErrorCode["GeneralError"] = 3] = "GeneralError";
    // Warning
    EmailErrorCode[EmailErrorCode["Warning"] = 100] = "Warning";
})(EmailErrorCode || (EmailErrorCode = {}));
EmailErrorCode['NOERROR'] = 0;
EmailErrorCode['USERIDNOTFOUND'] = 1;
EmailErrorCode['BRONTOERROR'] = 2;
EmailErrorCode['GENERALERROR'] = 3;
EmailErrorCode['WARNING'] = 100;
//# sourceMappingURL=EmailErrorCode.js.map